import { Box } from '@mui/material'
import { useIntl } from 'react-intl'
import SeoSales from '../../components/seo/SeoSales'
import BgImageTitleLayout from '../../components/Common/BgImageTitleLayout'
import FormContainer from './FormContainer'
import DealersFinderContainer from './DealersFinderContainer'

export default function Sales() {
  const intl = useIntl()

  return (
    <Box data-cy='sales-container'>
      <SeoSales
        title={intl.formatMessage({ id: 'seo.sales.title' })}
        description={intl.formatMessage({ id: 'seo.sales.description' })}
      />
      <BgImageTitleLayout
        title='sales.title'
        description='sales.description'
        bgImage='url(https://meteor.stullercloud.com/das/138561875)'
      >
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '3fr 2fr' }, gap: 6, mt: 4 }}>
          <FormContainer />
          <DealersFinderContainer />
        </Box>
      </BgImageTitleLayout>
    </Box>
  )
}
